import {CommonButtonLabel, FastRobotErrorcode, ModalSize} from 'constants/dataEnum';
import {showModal, hideModal} from 'stores/actions/modalStateAction';
import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import {loadCellError} from 'api/loadCellError';
import {hideLoading, showLoading, showSnackbar} from 'stores/actions/appStateAction';
import {resolveIntl, setErrorCodeNumber} from './commonBusiness';
// eslint-disable-next-line import/no-cycle
import {fastRecovery} from './recoveryBusiness';
import {isV2Instrument} from './instrumentStatusBusiness';

const intl = resolveIntl();

export const checkLoadCellError = (callback, recoveryCallback) => async (dispatch) => {
  if (!isV2Instrument()) return false;
  dispatch(showLoading('Loading...'));
  const result = await loadCellError();
  dispatch(hideLoading());
  if (result && result !== FastRobotErrorcode.NoError) {
    await dispatch(setErrorCodeNumber(result));
    dispatch(showLoadCellErrorModal(callback, result, recoveryCallback));
    return true;
  }
  return false;
};

export const showLoadCellErrorModal =
  (callback, errorCode, recoveryCallback, bypassRecoveryApiCall = false) =>
  (dispatch) => {
    let buttons = [
      {
        text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        onClick: () => {
          dispatch(hideModal());
          if (callback) callback();
        },
      },
    ];
    let message = 'loadCellErrorModal.unrecoverable.text';

    if (
      errorCode === FastRobotErrorcode.LOAD_CELL_VALUE_NO_CHANGE ||
      errorCode === FastRobotErrorcode.LOAD_CELL_READ_TIMEOUT
    ) {
      message = 'loadCellErrorModal.recoverable.text';
      buttons = [
        {
          text: intl.formatMessage({id: 'loadCellErrorModal.recoverable.button.recover'}),
          onClick: async () => {
            dispatch(hideModal());
            dispatch(showLoading(intl.formatMessage({id: 'loadCellErrorModal.recoverable.loading.text'})));
            const responseCallback = (result) => {
              if (result === FastRobotErrorcode.NoError || bypassRecoveryApiCall) {
                if (recoveryCallback) recoveryCallback();
                if (!bypassRecoveryApiCall) {
                  dispatch(showSnackbar('info', intl.formatMessage({id: 'loadCellErrorModal.recover.success'})));
                }
              } else {
                if (callback) callback();
                dispatch(showSnackbar('error', intl.formatMessage({id: 'loadCellErrorModal.recover.fail'})));
              }
            };

            if (!bypassRecoveryApiCall) {
              // respone = await tryRecoverLoadcellError();
              await dispatch(fastRecovery(null, null, responseCallback));
            } else responseCallback();

            dispatch(hideLoading());
          },
        },
      ];
    }
    dispatch(
      showModal(
        intl.formatMessage({id: 'loadCellErrorModal.title'}),
        <FormattedHTMLMessage id={message} />,
        buttons,
        () => {},
        '',
        true,
        ModalSize.MEDIUM,
      ),
    );
  };
